import { render, staticRenderFns } from "./xscx.vue?vue&type=template&id=3a216aba&scoped=true&"
import script from "./xscx.vue?vue&type=script&lang=js&"
export * from "./xscx.vue?vue&type=script&lang=js&"
import style0 from "./xscx.vue?vue&type=style&index=0&id=3a216aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a216aba",
  null
  
)

export default component.exports